module.exports = __webpack_public_path__ + "img/logo-hsinchu.a4332b64.png";